let imageContentContainer = document.querySelectorAll('.image-content');
if (imageContentContainer.length > 0) {
  imageContentContainer.forEach(container => {
    let imagewrap = container.querySelector('.imagewrap');
    // let imageHeight = imagewrap.offsetHeight;
    let imageHeight = imagewrap.clientHeight;
    console.log(imageHeight);
    console.log(window.innerHeight);
    imagewrap.style.top = (window.innerHeight - imageHeight) / 2 + 'px';
    console.log(container);
  });
}